import { getParamFromUrl } from './utils';
import { debounce } from './debounce';

export const searchableDropdownHandler = (dropdown, cb = null) => {

  if (!dropdown) return;

  const dropdownList = dropdown.querySelector('ul');

  if (!dropdownList) return;

  const isRequired = dropdown.getAttribute('required') === 'true';
  const errorMessage = dropdown.querySelector('[data-error]');
  const dropdownArrow = dropdown.querySelector('[data-dropdown-arrow]');

  const select = dropdown.querySelector('[data-searchable-dropdown] select');
  const selectedOption = select.querySelector('option[selected]');
  const selectFieldContainer = dropdown.querySelector('.dropdown_selected_input');
  const selectField = selectFieldContainer.querySelector('input');

  let isOpen = false;

  const onLoad = () => {
    const param = getParamFromUrl(dropdown.id);

    if (param) {
      select?.querySelector('option[selected]')?.removeAttribute('selected');
      const selectedElement = select?.querySelector(`option[value='${param}']`);
      selectedElement?.setAttribute('selected', '');
      select.value = param;
      selectField.value = selectedElement.value;
      onInput(selectField.value);
      cb?.(select.value);
      return;
    }

    select.value = selectedOption.value;
    selectField.value = selectedOption.textContent;
    onInput(selectField.value);
    cb?.(select.value);
  };

  const toggleDropdown = () => {

    dropdownList.classList.toggle('hidden');
    isOpen = !isOpen;
    dropdownArrow.setAttribute('aria-expanded', isOpen);
    dropdownArrow.setAttribute('aria-hidden', !isOpen);
    dropdownList.setAttribute('aria-hidden', !isOpen);

    dropdownList.classList?.contains('hidden') ? selectField.setAttribute('readonly', '') : selectField.removeAttribute('readonly');

    if (isRequired && dropdownList.classList?.contains('hidden')) {
      select?.value ? errorMessage?.classList?.add('hidden') : errorMessage?.classList?.remove('hidden');
      select?.value ? selectFieldContainer?.classList?.remove('input_error') : selectFieldContainer?.classList?.add('input_error');
    }
  };

  const onSelectItem = (el) => {

    const selectedValue = el?.closest('li').getAttribute('data-value');
    select.value = selectedValue;
    selectField.value = el.textContent;
    select?.querySelector('option[selected]')?.removeAttribute('selected');
    select?.querySelector(`option[value='${selectedValue}']`)?.setAttribute('selected', '');
  };

  const onInput = (searchTerm) => {
    let listHtml = '';

    if (searchTerm) {
      Array.from(select.children)?.forEach((item) => {
        if (item.getAttribute('value')?.toUpperCase()?.includes(searchTerm?.toUpperCase())) {
          listHtml += `<li data-value='${item.getAttribute('value')}' tabindex="0"><p>${item.textContent}</p></li>`;
        }
      });
    } else {
      Array.from(select.children)?.forEach((item) => {
        listHtml += `<li data-value='${item.getAttribute('value')}' tabindex="0"><p>${item.textContent}</p></li>`;
      });
    }

    dropdownList.innerHTML = listHtml;
  };

  selectField.addEventListener('keyup', debounce((e) => {
    if (e.isComposing || e.keyCode === 229) return;
    onInput(e.target.value);
  }, 500));

  dropdown.addEventListener('mousedown', (e) => {
    const element = e.target;

    if (element.hasAttribute('data-value') || element.parentElement.hasAttribute('data-value')) onSelectItem(element);

    if (!dropdownList.classList?.contains('hidden')) {
      cb?.(select.value);
      selectFieldContainer.removeEventListener('blur', null);
    }

    if (dropdownList.classList?.contains('hidden')) {
      selectFieldContainer.addEventListener('blur', (e) => {
        e.preventDefault();

        if (!dropdownList.classList?.contains('hidden')) {
          toggleDropdown();
          cb?.(select.value);
        }
      });
    }

    toggleDropdown();
  });

  selectFieldContainer.addEventListener('keyup', (e) => {
    e.preventDefault();
    if (e.key === 'Enter') toggleDropdown();
  });

  dropdownList.addEventListener('keydown', (e) => {
    if (e.key === 'Tab' && document.activeElement === dropdownList?.children[dropdownList?.children?.length - 1]) {
      e.preventDefault();
      Array.from(dropdownList?.children)?.[0]?.focus();
    }

    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onSelectItem(e.target);
      toggleDropdown();
    }
  });

  onLoad();
  return (cb = null) => {
    cb?.();
    select.value = '';
    select?.querySelector('option[selected]')?.removeAttribute('selected');
    const defaultItem = select?.children?.[0];
    defaultItem.setAttribute('selected', '');
    selectField.value = defaultItem?.textContent ?? '';
  };
};

